import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Text } from '../../components/Text';
import { LoadingBar } from '../../components/util/LoadingBar';
import Hint from '../../components/ModuleDrawer/Hint';
import { Checkbox } from 'rmwc/Checkbox';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { SelectControl } from '../../components/controls/SelectControl';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const StyledAnswerRow = styled.div`
  width: 80%;
`;

const incomeSpec = {
  field_type: 'single_choice',
  options: [0, 10500, 25500, 35500, 45500, 63000, 88000, 125500, 175500, 225500, 300500, 438750],
  option_data: {
    '0': { label: 'No Income' },
    '10500': { label: '$1,000-$20,000' },
    '25500': { label: '$21,000-$30,000' },
    '35500': { label: '$31,000-$40,000' },
    '45500': { label: '$41,000-$50,000' },
    '63000': { label: '$51,000-$75,000' },
    '88000': { label: '$76,000-$100,000' },
    '125500': { label: '$101,000-$150,000' },
    '175500': { label: '$151,000-$200,000' },
    '225500': { label: '$201,000-$250,000' },
    '300500': { label: '$251,000-$350,000' },
    '438750': { label: '$351,000+' },
  },
};

class Incomes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryBase: props.qna_hash.primaryBase ? props.qna_hash.primaryBase.answer : null,
      primarySelfEmployed: props.qna_hash.primarySelfEmployed ? props.qna_hash.primarySelfEmployed.answer : false,
      partnerBase: props.qna_hash.partnerBase ? props.qna_hash.partnerBase.answer : null,
      partnerSelfEmployed: props.qna_hash.partnerSelfEmployed ? props.qna_hash.partnerSelfEmployed.answer : false,
    };
  }

  componentDidMount() {
    this.props.pathAware('primaryBase');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.primaryBase) {
      let mergeState = {
        primaryBase: props.qna_hash.primaryBase.answer,
        primarySelfEmployed: props.qna_hash.primarySelfEmployed.answer,
      };
      if (props.qna_hash.hasPartner.answer) {
        mergeState.partnerBase = props.qna_hash.partnerBase.answer;
        mergeState.partnerSelfEmployed = props.qna_hash.partnerSelfEmployed.answer;
      }
      this.setState(mergeState);
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    let frame = {
      primaryBase: {
        question: "What's your annual income from work?",
        answer: this.state.primaryBase,
      },
      primarySelfEmployed: {
        question: 'Primary Self-Employed/Business Owner',
        answer: this.state.primarySelfEmployed,
      },
    };

    if (qna_hash.hasPartner.answer) {
      frame.partnerBase = {
        question: "What's your partner's annual income from work?",
        answer: this.state.partnerBase,
      };
      frame.partnerSelfEmployed = {
        question: 'Partner Self-Employed/Business Owner',
        answer: this.state.partnerSelfEmployed,
      };
    }

    this.props.continueOnboarding(qna_stack, qna_hash, frame).then(onContinue);
  };

  _canContinue = () => {
    return (
      this.state.primaryBase !== null &&
      (this.props.qna_hash.hasPartner.answer ? this.state.partnerBase !== null : true)
    );
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.value });
  };

  onToggle = (evt, field) => {
    this.setState({ [field]: evt.target.checked });
  };

  render() {
    const { qna_hash, wrapper } = this.props;

    if (!qna_hash.hasPartner) {
      return <LoadingBar />;
    }

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">What's your annual income from work?</Text>
        </div>
        <div style={{ width: '100%' }}>
          <Text use="body1" className="ml-4 mr-4">
            Enter your before-tax income across all your jobs. If your current income is temporarily lower than usual,
            enter an amount you could safely expect to earn going forward.
          </Text>
        </div>
        <StyledAnswerRow>
          <SelectControl
            id="primaryBase"
            label="You"
            value={this.state.primaryBase}
            spec={incomeSpec}
            onChange={evt => this.onChange(evt, 'primaryBase')}
          />
          <Checkbox
            id="primarySelfEmployed"
            onChange={evt => this.onToggle(evt, 'primarySelfEmployed')}
            checked={this.state.primarySelfEmployed}
            label="Self-Employed/Business Owner"
          />
        </StyledAnswerRow>

        {qna_hash.hasPartner.answer && (
          <StyledAnswerRow>
            <SelectControl
              id="partnerBase"
              className="mt-4"
              style={{ maxWidth: '700px' }}
              label="Your Spouse"
              value={this.state.partnerBase}
              spec={incomeSpec}
              onChange={evt => this.onChange(evt, 'partnerBase')}
            />
            <Checkbox
              id="partnerSelfEmployed"
              onChange={evt => this.onToggle(evt, 'partnerSelfEmployed')}
              checked={this.state.partnerSelfEmployed}
              label="Self-Employed/Business Owner"
            />
          </StyledAnswerRow>
        )}
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(Incomes);
